import { legacy_createStore as createStore } from 'redux'
import { combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { UPDATE_USER } from './user/user_reducers';
import { UPDATE_APPLICATION_DATA } from './application_data/data_reducers';
import { UPDATE_ARS_DATA } from './ars/ars_reducers';
import { UPDATE_SHOPFLOOR_DATA } from './shop_floor/shop_floor_reducers';
import { applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
}


const rootReducers = combineReducers({
    user: UPDATE_USER ,
    application : UPDATE_APPLICATION_DATA,
    ars:UPDATE_ARS_DATA,
    shop_floor:UPDATE_SHOPFLOOR_DATA
})

const persistedReducer = persistReducer(persistConfig, rootReducers)

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware()))
const persistor = persistStore(store);

export { store, persistor }